export default {
    AsterLeadInsert: {
        getdata: []
    }
};